// extracted by mini-css-extract-plugin
export var buttonContainer = "_93-1";
export var fontSizeSelect = "_93-3";
export var formatSelect = "_93-2";
export var formats = "_93-4";
export var hidden = "_93-5";
export var icon = "_93-6";
export var select = "_93-0";